import React from 'react';
import { AlertTriangle, CheckCircle, XCircle } from 'lucide-react';
import { Button } from './Button';
interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
  variant?: 'danger' | 'warning' | 'success';
}
export function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  onConfirm,
  onCancel,
  variant = 'warning'
}: ConfirmDialogProps) {
  if (!open) return null;
  const icons = {
    danger: <XCircle className="w-12 h-12 text-red-100 bg-red-600 rounded-full p-2" data-id="element-69" />,
    warning: <AlertTriangle className="w-12 h-12 text-amber-100 bg-amber-500 rounded-full p-2" data-id="element-70" />,
    success: <CheckCircle className="w-12 h-12 text-emerald-100 bg-emerald-600 rounded-full p-2" data-id="element-71" />
  };
  const confirmVariant = variant === 'danger' ? 'danger' : variant === 'success' ? 'success' : 'primary';
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" data-id="element-72">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6 animate-in fade-in zoom-in duration-200" data-id="element-73">
        <div className="flex flex-col items-center text-center mb-6" data-id="element-74">
          <div className="mb-4" data-id="element-75">{icons[variant]}</div>
          <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-76">{title}</h3>
          <p className="text-gray-500" data-id="element-77">{message}</p>
        </div>
        <div className="flex space-x-3 justify-end" data-id="element-78">
          <Button variant="outline" onClick={onCancel} className="flex-1" data-id="element-79">
            {cancelLabel}
          </Button>
          <Button variant={confirmVariant} onClick={onConfirm} className="flex-1" data-id="element-80">
            {confirmLabel}
          </Button>
        </div>
      </div>
    </div>;
}